module.exports={
    common:{
        connect:"连线",
        contactUs:"联络我们",
        learnMore:"进一步了解",
        trustedBy:"信任",
        sendSuccess:"发送成功!",
        sendFail:"发送失败!",
        lang:[
            {
                value:"EN",
                name:"英文"
            },{
                value:"CHT",
                name:"繁中"
            },{
                value:"CN",
                name:"简中"
            },{
                value:"JP",
                name:"日文"
            }
        ]
    },
    bannerTips:{
        square:"超过一百万平方英尺的制造空间",
        production:"精简了世界各地的生产设施",
        processes:"永续制程和环保材料"
    },
    footer:{
        letStarted:"立即使用",
        signTitle:"注册以收取新的讯息",
        signPlaceholder:"电子邮件信箱地址",
        signBtn:"发送",
        signTips:"您可以随时选择停止接收此类电子邮件。您提供的信息会受到 MPT Solution (HK) Limited 的隐私策略和条款规范。",
        privacyPolicy:"隐私策略",
        cookiePolicy:"Cookie 原则",
        termsOfUse:"使用条款",
        copyright:"Copyright © 2021 MPT Solution and its Affiliates and Subsidiaries. All rights reserved.",
        emailrRquired:"邮箱不能为空!",
        emailVaild:"メールボックスのフォーマットが間違っています!",
    },
    home:{
        worldMolding:{
            title:"世界级塑料部件生产商",
            text:"质量卓越， MPT solution是世界一流的外观塑料件生产商"
        },
        dell:{
            title:"「效能卓越及致力于服务机构 DGP」",
            text:"Dell Inc. 的 WWP Client NB Mechanical"
        },
        sevices:{
            title:"服务",
            text:"汉达精密提供高度精准的全面性机构解决方案。我们提供各种服务，例如模具设计、材质选择、优化制程以及更多的服务。"
        },
        injectMold:{
            title:"射出成型",
            text:"汉达精密拥有超过五千个客制模具案例和超过二十年的生产经验，可以提供的服务不限于制造机构部件。"
        },
        metal:{
            title:"金属加工",
            text:"汉达精密拥有完整的金属件制造能力。"
        },
        finishing:{
            title:"外观处理",
            text:"汉达精密提供各式各样的加工处理，为您的机构产品提供一站式服务。"
        }
    },
    aboutUs:{
        title:"我们是汉达精密",
        introText:{
            no1:"汉达精密自 1999 年起持续为全球领先业界的各企业开发精密机构部件。",
            no2:"汉达精密使用最先进的技术，生产精密的，高质量的、高良率的，美观的复合材料机构部件。除产品的质量外，我们同时加强了客户服务。让汉达精密充满创新的专属团队承接您的下一个构想，并将其化为现实。",
            no3:"在此深入了解我们的服务和核心竞争力。",
        },
        here:"在此",
        whyWorkWithUs:"与我们合作的理由",
        history:{
            title:"集团历史",
            textNo1:"MiTAC Precision Technology Corporation (MPT Solution)创立于 1999 年，现在已成为拥有世界一流的设计与制造能力的机构部件供货商，并拥有多年为国际大型客户提供服务的经验，包括国内外的领先企业和主要的原始设备制造商／原始设计制造商 (OEM/ODM)。",
            textNo2:"2007 年，汉达与台湾的上市公司神基科技正式合并，并以雄厚的资本和研发电子产品的能力为后盾，为顾客提供更完整的机构部件整合解决方案。",
            textNo3:"2009 年，投资了世界第三大镁铝合金制造公司 Waffer ，进一步增强了汉达精密的轻金属机构部件的制造能力。"
        }
    },
    affiliates:{
        title:"关系企业",
        introText:"汉达精密是 Getac Group 的子公司，而Getac Group是一家于 1989 年建立的跨国企业集团。Getac Group 的业务规模涵盖消费性电子产品、IT 信道、系统整合、软件开发、石化工业、工业气体和食物加工产业"
    },
    coreCompetencies:{
        title:"核心竞争力",
        prototypingServices:{
            title:"模型设计:",
            textList:[
                '3D打印（塑料&金属）',
                'CNC',
                '软胶铸造模',
                '金属冲压',
                '外观处理',
                '简易模具'
            ]
        },
        manufacturingServices:{
            title:"制造服务:",
            textList:[
                '模具自制',
                '大量制造',
                '小批量生产',
                '表面处理',
                '单件组装和整机模块组装',
                '包装',
                '工业自动化 (A.I.+IoT)'
            ]
        },
        integrationSolutions:{
            title:"整合解决方案:",
            textList:[
                '系统整合联合开发',
                'CMF 联合开发',
                '机构部件联合开发',
                '制造程序开发',
                '材料开发'
            ]
        },
        testingCertification:{
            title:"测试和认证:",
            textList:[
                '机构部件测试',
                '塑料材料测试',
                '环境模拟',
                '区域安全认证'
            ]
        }
    },
    sustainability:{
        title:"可持续发展",
        carbonFootprint:"「碳足迹」已成为全球各大企业深入研究和探索的环境保护趋势之一。因此，MPT Corp. 持续在履行其与环境保护有关的企业管理职责。",
        pdaComponent:"汉达精密自 2011 年 4 月开始使用「PDA 组件」产品，成功执行了碳足迹计划。根据《碳足迹计算准则》(Carbon Footprint Calculation Guideline)，DPA 组件产品在整个生命周期中会产生 8.741kg CO2e/unit的温室气体。在原材料、制造和运输三个阶段中，制造阶段会产生大部分的碳排放，占总排放量的 82.12%，其次是原材料阶段的 17.87%，运输阶段则占 0.01%。此情形表示想要真正实现环境保护，即必须加强产品制造阶段的绿色处理计划。",
        frontrunner:"汉达精密为环保道路上的先行者，已经积累了为客户提供服务的雄厚实力，将能与客户携手创造更环保的产品。"
    },
    integrityManagement:{
        title:"诚信经营",
    },
    sustainableReport:{
        title:"永续报告",
        csrTitle:"CSR报告书",
        zcTitle:"政策与宣言"
    },
    technologySolutions:{
        title:"技术解决方案",
        introText:"汉达精密采用最先进的技术，提供高质量、高产能与美观的机构部件，满足客户的个性化需求。创新化的量产技术，使我们可以精准地高效的实现您的期望。"
    },
    injectionMolding:{
        title:"射出成型",
        introText:"汉达精密是高质量射出成型服务的业界领导者。我们有超过五千套客制模具制作和二十年以上的成型生产经验，提供的不仅仅是精密机构部件产品，更能满足您对最具挑战性的客制化产品的需求。我们提供从设计模具，到成品生产的完整的解决方案。"
    },
    cosmeticFinishing:{
        title:"表面处理",
        introText:"汉达精密具有各类型的表面处理技术，满足您对于各种外观的高标准要求。"
    },
    metalFabrication:{
        title:"金属加工",
        introText:"汉达精密可提供完整的金属加工，包括冲压成型、喷砂和表面处理。"
    },
    composite:{
        title:"复合材料",
        introText:"汉达精密解决方案使我们的客户可以使用复合材料设计与制造出更轻巧及更坚韧的零件。"
    },
    material:{
        title:"材料",
        introText:"汉达精密是经过认证的消费后树脂 (Post Consumer Resin, PCR) 制造商。我们拥有完整的专利布局，从材料开发、制程设计，延伸至验证和属性测试。"
    },
    capabilities:{
        trustedBy:"深受于全球性品牌的信赖",
        ourCapabilities:{
            title:"我们的能力",
            introText:"汉达精密采用最先进的技术，根据客户的个别需求，提供高质量、高产量与美观的机构部件。我们独特、先进的制造工艺和创新的批量生产技术，使我们可以精准地实现您的期望。我们在亚洲拥有多个制造工厂，并拥有二十多年的经验，可以为世界领先之公司提供全面的机构部件解决方案。在此深入了解我们的核心竞争力。",
            fullList:"完整的设备清单"
        },
        engineeringConsulting:{
            title:"工程与咨询",
            introText:"我们拥有两百多位经认证的工程师以及二十多年开发精密机构部件的经验，有能力可以协助您提高开发速度与降低成本。"           
        },
        certifications:{
            title:"认证",
            introText:"汉达精密已通过 ISO 和 IATF 认证。质量是我们的首要任务。 深入了解我们的认证。"
        },
        massProduction:{
            title:"量产",
            introText:"在过去二十多年，汉达精密一直与世界领先的公司合作，做为其专属的精密机构部件合作伙伴。"
        },
        automation:{
            title:"自动化",
            introText:"汉达精密是在业界内较早引入自动化生产系统的企业之一。我们可以透过自动化系统加快生产速度。"
        }
    },
    certifications:{
        title:"认证",
        itemList:[
            "通过 TUV 的 ISO 9001 认证（2007 年）",
            "通过 TUV 的 ISO14001 认证（2007 年）",
            "通过 TUV 的 OHSAS18000 认证（2007 年）",
            "获得 NIK 的绿色供应商认证（2010 年）",
            "Canon 认证的 GP（2010 年）",
            "通过 BSI 的 ISO 9001 认证（2010 年）",
            "通过 BSI 的 ISO 14001 认证（2010 年）",
            "通过 BSI 的 ISO 18001 认证（2010年）",
            "Canon 认证的 GP（2013 年）",
            "通过 BSI 的 ISO14001 认证（2013 年）",
            "通过 BSI 的 ISO 18001 认证（2013 年）",
            "通过 BSI 的 ISO 9001 认证（2013 年）",
            "通过 SGS 的 TS 16949 认证（2014 年）",
            "通过 BSI 的 ISO14001 认证（2016 年）",
            "通过 BSI 的 ISO 18001 认证（2016 年）",
            "通过 SGS 的 ISO 9001 认证（2018 年）",
            "通过 SGS 的 IATF16949 认证（2018 年）",
            "通过 BSI 的 ISO 45001 认证（2018 年）",
            "通过 BSI 的 OHSAS18001 认证（2018 年）",
            "SONY 绿色合作伙伴证书的通知（2019 年）",
            "TUV 授予经 RBA 验证的评估计划金奖（2020 年）"
        ]
    },
    engineeringConsulting:{
        title:"每一个设计都包含卓越和创新",
        introText:"汉达精密认为创新是企业成长的关键。让我们协助您取得竞争优势、承接您的下一个构想，并将其化为现实。"
    },
    testingLab:{
        title:"测试实验室",
        introText:"汉达精密拥有经中国合格评定国家认可委员会 (CNAS) 认可之检测实验室（实验室编号：L5893）。我们大量投资于机构件的相关研究与开发，拥有设备齐全的测试实验室可以提供材料和产品的全面性分析测试。",
        mechanical:{
            title:"机械性能测试:",
            text:   "• 拉伸和弯曲测试<br>"+
                    "• 夏氏和艾氏冲击试验<br>"+
                    "• 拉力降服和伸长率测试<br>"+
                    "• 微视硬度<br>"+
                    "• 合金材料之金相分析与失效分析<br>"+
                    "• 安装和抛光<br>"+
                    "• 扫描式电子显微镜<br>"+
                    "• 微结构和元素分析"
        },
        material:{
            title:"塑料材料测试:",
            text:"• 热重分析仪 (TGA) <br> "+
                "• 微分扫描卡计 (DSC) <br>" +
                "• 傅立叶变换红外光谱仪 <br>"+
                "• 热变形温度测试仪 (HDT及Vicat) <br>"+
                "• 熔体流动速率 <br>"+
                "• 燃烧性能测试试验（UL 测试） <br>"+
                "• 加工和流变性质（HAAKE 流变仪）"
        },
        environmental:{
            title:"环境模拟: ",
            text:   "• 中性盐雾测试 <br>"+
                    "• 恒温恒湿测试 <br>"+
                    "• 冷热冲击测试"
        },
        other:{
            title:"其他测试:",
            text:   "• 电化学工作站 <br>"+
                    "• 光泽度测试 <br>"+
                    "• 铅笔表面硬度测试 <br>"+
                    "• RCA 测试 <br>"+
                    "• 色差仪 <br>"+
                    "• 电阻率测试 <br>"+
                    "• 萧氏硬度测试"
        }
    },
    prototyping:{
        title:"模型设计",
        introTtile:"让方案变成现实",
        introText:"制作模型从未如此容易。让我们协助您以无可比拟的速度设计高精度和高质量的模型！",
        tips:"汉达精密的原型制作中心可以提供各种高分辨率的快速原型制作解决方案，例如 CNC、3D 列印、氨基甲酸乙酯铸件和热压成型等。"
    },
    locations:{
        title:"地点",
        introText:"汉达精密拥有的数百位全职设计人员，皆秉持着对精密零件制造业务的热情和专业知识，致力开发创新的制造程序与材料，以因应任何挑战。<br>先进的工程与全球制造地点:"
    },
    FAQ:{
        title:"常见问题",
        introText:"有问题吗？我们会在此回答！如果您没有在此部分看到您的问题，请透过我们的联络页面传送讯息给我们。"
    },
    contactUs:{
        title:"联络我们",
        firstName:"名字",
        lastName:"姓氏",
        email:"电子邮箱",
        message:"讯息",
        additionalDetails:"其他信息",
        sendMessage:"传送讯息",
        howHelp:"我们能如何协助您？",
        trustedBy:"信任"
    },
    privacyPolicy:{
        title:"隐私策略",
        A:{
            title:"A. 本隐私权注意事项",
            textItem:[
                "MPT Solution (HK) Limited 及其子公司 (MPT Solution) 致力于保护个人和个人敏感数据的隐私，且必须遵守《2018 年英国数据保护法》和《欧盟一般数据保护规则》(GDPR)，以及全世界其他国家的类似相关法律。本隐私权注意事项已构成汉达精密义务的一部分，以便能公开与公平地处理汉达精密处理的所有个人和个人敏感资料，并提供与处理个人资料之方式及用途有关的详细信息。",
                "汉达精密会处理其客户和合作伙伴的个人资料，例如姓名、联络方式和电子信箱地址等。处理资料系指收集、储存、使用、揭露或处置个人资料。",
                "利用汉达精密的解决方案和服务，或使用汉达精密网站的现有或潜在客户和合作伙伴的个人，可能会收到进一步的隐私权注意事项，且此类注意事项可能是包含在单独的增补通知中。此类额外的隐私权注意事项应做为补充本隐私权注意事项的内容。",
                "本隐私权注意事项与汉达精密处理个人资料有关。除另有说明外，本文件中提及之所有「我方」或「我方的」，应指所有处理个人或个人敏感数据的汉达精密业务线。本隐私权注意事项的对象为本组织以外与我方互动的个人，包括消费者和我方网站的浏览者（合称为「您」）。本隐私权注意事项中使用的定义术语会在下文 (Q) 节中阐明。",
                "MPT Solution为本隐私权注意事项的数据控制者。联络方式，请参见下文第 (N) 节。",
                "本隐私权注意事项将会不时进行修订或更新，以反映我方处理个人资料之做法的改变或适用法律的变更。我方鼓励您详细阅读本隐私权注意事项及定期查看本页面，以审查我方可能会根据本隐私权注意事项之条款进行的任何变更。",
                "本隐私权注意事项中提供之列表或范例皆非详尽无疏漏或完全代表每一个人。"
            ],
            scope:{
                title:"范围",
                textItem:[
                    "本隐私权注意事项之范围，包括现有／潜在之客户与合作伙伴的下列个人资料：",
                    "•&nbsp;&nbsp;&nbsp;&nbsp;收集个人资料 <br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;处理个人资料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;使用个人资料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;揭露个人资料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;国际资料传输<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;资料正确性<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;资料最小化<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;保留个人资料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;保障个人资料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;资料主体权利<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;Cookie<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;联络方式<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;投诉"
                ]
            }
        },
        B:{
            title:"B. 收集您的个人资料",
            textItem:[
                "我方可能会收集与您有关的个人资料，例如您的姓名、地址和联络方式。我方可能会收集个人资料的来源，包括：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您提供给我方的个人资料（例如您联络我方时的电子邮件、电话或任何其他方式）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;您在我方与您的正常关系中提供给我方的个人资料（例如：您向我方购买产品或服务）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;您明示选择公开的个人资料，包括透过社交媒体选择公开您的个人资料以供查看。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方从第三方（例如合作伙伴、信用参考机构和执法机关等）取得的个人资料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在您造访任何汉达精密网站（「网站」），或使用网站本身或透过其提供之任何功能或资源时，我方取得与您有关的个人资料。在您造访网站时，您的装置和浏览器自动揭露的某些资讯（例如装置类型、作业系统、浏览器类型、浏览器设定、IP 位址、语言设定、连线至网站的日期和时间，以及其他技术通讯资讯）。",
                "我方也可能会建立与您有关的个人资料，例如您与我方的互动记录，以及购买历史记录的详细资料，涵盖：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;个人详细资料：姓名、偏好名称、性别、出生日期／年龄、国籍、照片。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;联络方式：送货地址、电话号码、电子信箱地址、社交媒体的个人档案详细资料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;付款详细资料：帐单地址、银行帐号或信用卡号码、持卡人或帐户持有人姓名、卡片或帐户安全性详细资料、卡片的生效日期、卡片的到期日。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;观点和意见：您选择传送给我方的任何观点和意见，或在社交媒体平台上公开发表与我方有关的观点和意见。"
            ]
        },
        C:{
            title:"C. 处理您的个人资料",
            textItem:[
                "我方得使用以下内容做为处理您的个人资料之合法依据。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您已经事先向我方明确表示，仅同意针对完全自愿之事项处理您的个人资料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;该处理为您可能与我方签订之任何合约的相关必要事项。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;适用法律要求的处理，或<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方拥有为了管理、经营或促进我方业务之目的进行处理的合法利益，且该合法利益不会与您的利益、基本权利或自由发生冲突。"
            ]
        },
        D:{
            title:"D. 使用您的个人资料",
            textItem:[
                "我方得为下列目的而使用您的个人资料：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;运营和管理我方的网站：为您提供内容、显示广告和其他资讯，以及透过我方的网站与您进行沟通和互动。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;为您提供产品和服务：为您提供我方的网站和其他服务、提供您购买的产品、依据您的要求提供促销商品、针对前述产品和服务与您进行沟通。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;行销通讯：透过任何方式（包括透过电子邮件、电话、简讯、社交媒体、邮寄或亲自）寄送您可能感兴趣的新项目和其他资讯，但是必须确保依据适用法律为您提供此类通讯。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;通讯和 IT 营运：管理我们的通讯系统、IT 安全性营运以及 IT 安全性稽核。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;健康和安全性：评估健康和安全性与保存记录，以及遵守相关的法律义务。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;财务管理：销售、财务、公司稽核、厂商管理。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;调查：与您接触以了解您对我方之的产品和服务的意见。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;改善我方的产品和服务：确认现有产品和服务的问题、计画改进现有的产品和服务、创造新的产品和服务。"
            ]
        },
        E:{
            title:"E. 揭露个人资料",
            textItem:[
                "我方可能会将您的个人资料揭露予 Getac 集团中的其他实体（包括为您提供服务和经营我方的网站）。",
                "此外，我方可能会将您的个人资料揭露给以下人员：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;法律和监管机构，依据要求或为了报告任何实际或涉嫌违反适用法律或法规的行为。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;会计师、稽核员、律师和其他汉达精密的外部专业顾问，是必须遵守具有约束力的保密合约义务。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;汉达精密的经销商、分销商和第三方业务伙伴，以便在签订合约之前，依据您的要求采取措施或履行合约。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;世界各地的第三方处理者（例如付款服务供应商、航运公司、电话行销公司、资料供应服务供应商、资料清理服务供应商等），但是必须符合本第 (E) 节中所述之要求。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相关方、执法机构或法院，在建立、行使或捍卫法律权利的必要范围内。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相关方为预防、调查、侦查或起诉刑事犯罪或执行刑事处罚之目的，包括保障对于公共安全具有约束力的合约保密义务和防止对其造成威胁。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相关的第三方收购者，如果我方出售或转让我方业务或资产的全部或任何相关部分（包括在重组、解散或清算的情况下）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;使用第三方外挂程式或内容，在我方网站上提供社交媒体平台的第三方供应商（例如 LinkedIn、YouTube 和 Facebook）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方聘请第三方处理者处理您的个人资料时，该处理者将会受具有约束力之合约义务的约束，以便：<br/>•&nbsp;&nbsp;&nbsp;&nbsp;仅依据我方之事先书面指示处理个人资料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;采取措施保护个人资料的保密性和安全性，以及适用法律的其他任何要求。" 
            ]
        },
        F:{
            title:"F. 个人资料的国际传输",
            textItem:[
                "由于我方业务具有国际性质，可能需要依据本隐私权注意事项中规定之目的，在 Getac 集团内部传输您的个人资料以及传输给上文第 (D) 节所述的第三方。因此，我方可能会将您的个人资料传输至法律和资料保护合规性要求可能与您所在国家不同的其他国家。将包括在欧洲经济区 (EEA) 以外传输、处理和储存个人资料。",
                "我方将会根据《标准个资保护契约条款》，将您的个人资料传输至其他国家。您可以透过以下第 (N) 节部分提供的联络方式，索取一份我方的《标准个资保护契约条款》副本。",
                "我方使用欧洲经济区以外的第三方资料处理者，做为提供给您之服务的一部分，如下文所述：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;管理客户、合作伙伴和联络人的 Salesforce.com，总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供设备运送和服务支援的联邦快递 (FedEx Corporation)，总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;负责行销活动的 The Rocket Science Group（以 Mailchimp 的名义进行交易），总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供付款服务的 PayPal Inc.，总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供云端服务的亚马逊网路服务公司 (Amazon Web Services, Inc.)，总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供云端服务的微软公司 (Microsoft Corporation, Microsoft Azure)，总部位于美国。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;若需要更多与欧洲经济区以外之第三方资料处理者有关的资讯，以及获得我方与其签订之资料保护协议的副本时，请透过以下第 (N) 节提供的联络方式与我方联络。"
            ]
        },
        G:{
            title:"G. 资料正确性",
            textItem:[
                "我方采取一切合理的措施，确保：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您的个人资料准确，并在您通知我方的情况下保持最新状态，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方会在收到您的通知后，删除或更正任何不准确的个人资料。",
                "我方可能会不时要求确认您的个人资料之准确性。"
            ]
        },
        H:{
            title:"H. 资料最小化",
            textItem:"我方会采取一切合理措施，确保我方在处理的您的个人资料时，仅会处理与本隐私权注意事项规定之目的有关合理要求的个人资料。"
        },
        I:{
            title:"I. 资料保留",
            textItem:[
                "确定我方保存您的个人资料之期间的标准，如下：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;我方将以允许识别之形式保留您的个人资料副本，但是仅限与我方使用该资料之目的有关的必要时间，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;适用法律要求之更长的保留期。特别是，我方可能会在建立、行使或捍卫任何法律权利需要的任何期限内，保留您的个人资料。"
            ]
        },
        J:{
            title:"J. 保障个人资料",
            textItem:[
                "汉达精密做为个人资料的控制者，将会确保采取必要和充分的保障措施，防止未经授权存取、损失、滥用或变更您的个人资料。",
                "我方会将所有个人资讯均储存在具有相关之存取和防火墻控制项的安全伺服器上。",
                "使用书面或电子邮件形式传送任何个人资料给我方的传输过程可能不安全，我方无法保证交付。",
                "密码必须保密，不得揭露予第三方。汉达精密不会要求您提供密码。"
            ]
        },
        K:{
            title:"K. 资料主体权利",
            textItem:[
                "根据您的国籍（例如：欧盟公民）和住所的适用法律，您在处理您的个人资料方面可能享有部分权利，包括：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;要求存取我方处理或控制之您的个人资料或取得副本的权利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;要求修正我方处理或控制之您个人资料中之任何不准确的权利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;删除我方处理或控制之您的个人资料，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;限制处理我方处理或控制之您的个人资料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;以合法之理由，反对我方或代表我方处理您的个人资料的权利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在适用之范围内，要求将我方处理或控制之您的个人资料转移给另一个控制者的权利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在我方依据您的同意处理您的个人资料之情况下，撤回该同意的权利，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;针对我方或代表我方处理您的个人资料，向资料保护机构提出申诉的权利。",
                "将不影响您的法定权利。",
                "在想要行使上述一项或多项权利，或提出与这些权利或本隐私权注意事项中之任何其他规定，或我方处理您的个人资料有关的问题时，请使用下文第 (N) 节中提供的联络详细资料。"
            ]
        },
        L:{
            title:"L. Cookie",
            textItem:"Cookie 是一种在您造访网站（包括我方的网站）时，放置于您的装置上的小型档案。它会记录与您的装置、您的浏览器以及您在部分情况下的偏好和浏览习惯有关的资讯。根据我方的 Cookie 原则，我方可能会透过 Cookie 技术处理您的个人资料。更多与我方如何使用 Cookie 的相关资讯，请参阅我方的 Cookie 原则。"
        },
        M:{
            title:"M. 使用条款",
            textItem:"使用我方网站，即必须遵守我方的使用条款。"
        },
        N:{
            title:"N. 联络方式",
            textItem:"如果您对于本隐私权注意事项中的任何资讯，或与汉达精密处理个人资料有关的任何其他问题有任何意见、问题或疑虑，请联络：",
            contact:"11568 台湾台北市 <br/>南港区南港路一段 209 号<br/>A 栋 5 楼法务中心<br/>收件人：资料保护经理<br/>电子信箱： dpm.LAC@getac.com.tw<br/>电话：+886 (0)2 2785 7888"
        }
    },
    cookiePolicy:{
        title:"Cookie 原则",
        textItem:"本 Cookie 原则适用于列示在本原则末端，由 MPT Solution (HK) Limited 代表其本身、其子公司和其关系企业（合称「汉达精密」）运营或控制的网站。",
        which:{
            title:"本原则适用之网站",
            textItem:[
                "本原则适用于以下由 Getac 和汉达精密经营或控制的网站。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;http://www.mpt-solution.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://de.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://en.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://es.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://fr.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://intl.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://it.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://ru.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://getac.co.uk/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://latam.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://tw.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.cn/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://apac.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://us.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://mx.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.mx/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://be.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://www.getacestore.com/<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://partners.getac.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://rma.getac.com"
            ]
        },
        what:{
            title:"什么是 Cookie？",
            textItem:[
                "Cookie 是一种在您浏览一个网站时，可能会储存在您的计算机或其他装置上的小型文件档案。其一般是用于使网站正常工作、追踪您在网站中的活动、记住登入的详细资料等。",
                "Cookie可以根据来源、功能和周期，区分为不同的类型。Cookie 的重要特征包括以下：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;第一方 Cookie 是正在浏览之网站放置的 Cookie，而第三方是由正在浏览之网站以外的网站放置。请注意，我方无法控制第三方收集或进一步使用数据。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;必要的 Cookie 在允许网站的技术操作方面具有必要性（例如：Cookie 让您可以在网站上移动及使用其功能）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;效能 Cookie 会收集与网站效能有关的资料，例如浏览者的数量、在网站上花费的时间和错误讯息。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;功能 Cookie 会透过记住您的选择（例如语言、地区、登入等），提高网站的可用性。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;目标／广告 Cookie 使网站可以传送个人化的广告给您。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;会话 Cookie 是暂时性的 Cookie，会在您关闭浏览器时删除，而持续性或永久性 Cookie 会保留在您的装置上，直至手动删除，或您的浏览器根据持续性 Cookie 文件中指定的持续时间进行删除。<br/>",
                "更多与 Cookie 之各方面有关的信息，请浏览 www.allaboutcookie.org。请注意，汉达精密与该第三方网站无任何关联性，且无须为其负责。"
            ]
        },
        why:{
            title:"我方为什么使用 Cookie？",
            textItem:[
                "我方可能会为下列目的使用 Cookie：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;区分使用者，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;改善我方网站的使用和功能，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;根据您的需要和偏好，制定我方的网站和产品，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;处理您的购买订单，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;分析我方网站的使用方式，并编译匿名和汇总的统计资料。<br/>",
                "我方不会使用收集的信息建立用户个人资料。"
            ]
        },
        whatTypes:{
            title:"我方使用哪些类型的 Cookie？",
            textItem:[
                "下表概述了本网站使用的 Cookie。",
                "请注意，与 Cookie 有关和为其他目的而处理之您的个人资料，都会受到我方的隐私权原则规范。",
                "此外，我方也可能会使用 Web 指标（或清晰的 GIF 档）和其他类似技术，补充或结合使用 Cookie。Web 指标通常是个透明的图形影像（通常为 1 像素 × 1 像素），放置于网站上或电子邮件中，协助我方了解我方网站之浏览者的行为。更多与 Web 指标有关的资讯，请浏览 http://www.allaboutcookie.org/web-beacons/。请注意，汉达精密与该第三方网站无任何关联性，且无须为其负责。"
            ]
        },
        howCan:{
            title:"您如何控制 Cookie 和 Web 指标？",
            textItem:[
                "大部分的网际网路浏览器都会设定为自动接受 Cookie。您可以根据您的浏览器，将浏览器设定为在接受 Cookie 之前发出警告，或将其设定为拒绝接受。请参考您的浏览器上的「帮助」按钮（或类似按钮），以深入了解如何进行该动作。",
                "禁用 Cookie 可能会影响您在我方网站上的体验。",
                "如果您使用不同的装置造访我方网站时，将需要确保每一部装置的每一个浏览器都会设定为您的 Cookie 偏好设定。",
                "更多与管理 Cookie 之方式有关的资讯，请浏览：http://www.allaboutcookie.org/manage-cookie/。请注意，汉达精密与该第三方网站无任何关联性，且无须为其负责。",
                "此外，您可以透过浏览以下网站及选择想要拒绝接受的公司，以禁用其 Cookie： http://www.aboutads.info/choices/#completed 和 http://www.youronlinechoices.com/。请注意，汉达精密与这些第三方网站无任何关联性，且无须为其负责。"
            ]
        }
    },
    termsUse:{
        title:"使用条款",
        textItem:"本使用条款（以下称 「使用条款」）仅适用于 MPT Solution (HK) Limited 及其关系企业（以下称「MPT Solution」）的网站 mpt-solution.com（以下称「网站」）。请注意，本网站上之个别页面或材料，可能具备各自的条款和条件。在使用网站上的这些页面或材料时，必须遵守上述之个别条款和条件以及使用条款。如果使用条款的任何条件与上述个别条款和条件之间存有任何冲突时，应以该等个别条款和条件为准。",
        accessing:{
            title:"1.存取网站",
            textItem:[
                "在存取和使用本网站时，必须遵守以下使用条款与此处包含的所有条款和条件，或本网站上规定的任何个别条款和条件，且应视为您已经接受所有的这些条款。如果您不同意所有的这些使用条款，则不应使用本网站。",
                "MPT Solution 可以随时修订这些使用条款。此类修订的使用条款应在本网站上公布后生效。请定期查看本网站发布的使用条款，以确保您了解与存取和使用本网站有关的所有条款。其他 MPT Solution 网站可能具有本身之适用于这些网站的使用条款。"
            ]
        },
        legal:{
            title:"2.免责声明和责任限制",
            textItem:[
                "本网站是以「原样」提供所有的内容和其他信息。MPT Solution 兹此明确声明，不任何形式提供明示或暗示的陈述或保证，包括但不限于适销性、任何特定目的之适用性、非侵权性的保证，或本网站之运作或内容或其他信息的保证。Mpt Solution 不针对本网站之安全性提供任何保证或陈述。您承认传送的任何信息可能被拦截。Mpt Solution 不保证本网站或使本网站可用的服务器或由 Mpt Solution 传送的电子通讯，不会包含病毒或任何其他有害元素。",
                "MPT Solution 不保证网站发布之任何信息的准确性、可靠性或及时性，且不为与本网站连结的任何内容、观点、产品或服务背书，以及不对因依赖这些信息之准确性、可靠性或及时性，而造成的任何损失负责。这些信息的部分内容可能是不正确的或不是最新的。任何依赖从本网站获得的任何信息的个人或实体都要承担自身的风险。",
                "MPT Solution 保留在任何时候变更或更新本网站的任何和所有内容或信息或其格式的权利，且无需事先通知。MPT Solution 自行决定保留以任何理由终止或限制您存取本网站的权利。",
                "在任何情况下，MPT Solution 或其任何关系企业均不对任何直接、间接、后果性、惩罚性、特殊或偶然的损害（包括但不限于业务、合约、收入、数据、信息损失或业务中断的损害），或因使用或无法使用本网站或其内容而引起的或与之有关的损失负责，即使 MTP Solution 已知可能会发生此类损失亦同。任何针对 MPT Solution 提起或与本网站有关的诉讼，都必须在诉讼理由产生后一年内开始，并书面通知 MPT Solution。如果您因为使用本网站之内容、信息或服务，而导致需要维护、修理或更正设备或数据时，应自行承担所有的相关费用。",
                "本网站可能会提供其他不受 MPT Solution 控制的网站的连结。MPT Solution 对此类其他网站的内容，概不负责。MPT Solution 提供此类连结仅是为了方便本网站的使用者，因此包含任何此类网站的连结，不代表 MPT Solution 认可此类网站的内容。"
            ]
        },
        copyright:{
            title:"3.著作权",
            textItem:"本网站及其中提到的所有材料，包括但不限于软件、音频、影片、文字、影像和照片（以下称 「内容」）的著作权和所有其他所有权，均归属于 MPT Solution、其关系企业或其授权人。保留此处未明确授予之内容中的所有权利。除另有规定外，本网站发布的内容得以未经修改的形式复制或分发，仅供个人非商业使用。未经 MPT Solution 事前书面同意，严格禁止以任何其他方式使用内容，包括但不限于分发、复制、修改、展示或传输。应在所有复制品上保留所有的著作权和其他的所有权声明。"
        },
        trademark:{
            title:"4..商标、商号、商业外观、著作权和知识产权",
            textItem:[
                "MPT Solution 的商标、商号、商业外观、著作权和知识产权均为宝贵的资产，且我方致力于努力保护它们。因此，未经 MPT Solution 事前正式书面允许，任何经销商、分销商或集成商皆不得使用任何方式玷污或改变任何 MPT Solution 产品或包装，特别是删除、改变或掩盖其中的 MPT Solution 标志或其他所有权通知，且严格禁止。任何未经授权将产品重新命名或重新黏贴标签，以及导致习惯上识别产品的术语消失的行为，均已侵犯 MPT Solution 的知识产权和权利。",
                "如果您在商标、商号、商业外观、著作权和知识产权方面有任何疑问时，请将您的疑问提交给 MPT Solution。"
            ]
        },
        governing:{
            title:"5.管辖法律和管辖权",
            textItem:"本使用条款应以中华民国法律为准据法，并依其解释，不考虑其法律冲突原则。您与 MPT Solution 之间因本网站引起或与本网站有关的任何索赔或争议，均应受中华民国台湾台北地方法院专属管辖。"
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/cn.js